import React, { FC, useState } from "react";

import { Icon } from "~/ui";

type PropsType = {
  title: string;
  children: React.ReactNode;
  className?: string;
};

export const CollapsibleSection: FC<PropsType> = ({
  title,
  children,
  className = "",
}: PropsType) => {
  const [isCollapsed, setIsCollapsed] = useState(true);
  const toggleCollapse = () => setIsCollapsed(!isCollapsed);

  return (
    <div className={`${className}`}>
      <div
        className="flex items-center justify-between cursor-pointer bg-gray-100 p-3 rounded-t"
        onClick={toggleCollapse}
      >
        <h2 className="text-lg font-bold">{title}</h2>
        <Icon
          icon={isCollapsed ? "ioAdd" : "ioRemoveOutline"}
          size="1.5rem"
          className="shrink-0"
        />
      </div>
      {!isCollapsed && (
        <div className="border border-t-0 rounded-b py-4 px-8 space-y-6">
          {children}
        </div>
      )}
    </div>
  );
};
